'use strict';

const Mn = require('backbone.marionette');
const ContainerRepository = require('data/domain/repository/container/index');
const ContentActionWorkRepository = require('balus/infra/repository/actionwork/content');
const ActionContentVersionListView = require('balus/ui/view/additional/recommend/content-list');
const Template = require('balus/ui/template/additional/recommend/index.hbs');

class RecommendView extends Mn.View {
    get template() {
        return Template;
    }

    get className() {
        return 'additional';
    }

    regions() {
        return {
            contentVersionList: '.content-version-list'
        };
    }

    get childViewTriggers() {
        return {
            'add:content:comment': 'add:content'
        };
    }

    get childViewEvents() {
        return {
            'show:action:contents': 'showActionContents',
            'hide:action:contents': 'hideActionContents'
        };
    }

    templateContext() {
        const context = this.getOption('context');

        return {
            isAction: context.get().key.kind == 'Action'
        };
    }

    onRender() {
        const context = this.getOption('context');

        if(context.get().key.kind == 'Action') {
            const action = context.get();
            const project = action.getProject();

            ContainerRepository.find(project)
                .fetchRootOnce()
                .then(rootContainer => {
                    if(!rootContainer.id) {
                        return;
                    }
                    ContentActionWorkRepository.find(project)
                        .fetchActionWorksByActionOnce(action, 1)
                        .then(actionWorks => {
                            this.showChildView('contentVersionList', new ActionContentVersionListView({
                                collection: actionWorks,
                                action: action
                            }));

                            if(!actionWorks.length) {
                                this.hideActionContents();
                            }
                        });
                });
        }
    }

    open() {
        const contentVersionListView = this.getChildView('contentVersionList');
        if(contentVersionListView) {
            contentVersionListView.open();
        }
    }

    cleanup() {
        this.render();
    }

    showActionContents() {
        this.$('.recommend-action-contents').show();
    }

    hideActionContents() {
        this.$('.recommend-action-contents').hide();
    }
}

module.exports = RecommendView;



// WEBPACK FOOTER //
// ./balus/ui/view/additional/recommend/index.js